module.exports = __webpack_public_path__ + "static/media/confetti-horn.5776b6dd.svg";